<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">文章动态</span>
      </div>
    </div>
    <div class="box1"
         v-show="boxIndex == 1">
      <div class="b1top">
        <div class="b1tl">
          <span @click="b1Index = 1"
                :style="b1Index == 1 ? 'color: #0B8586;' : ''">上传文章</span>
          <span @click="b1Index = 2"
                :style="b1Index == 2 ? 'color: #0B8586;' : ''">草稿箱（{{ draftNum }}）</span>
        </div>
        <div class="b1tr"
             @click="boxIndex=2"
             style="cursor:pointer">
          <img src="../../assets/img/icon/jia2.png"
               alt="" />
          <span style="margin-right:0">新增</span>
        </div>
      </div>
      <div class="listbox">
        <table v-if="b1Index == 1">
          <thead>
            <tr>
              <th>文章题目</th>
              <th>审核状态</th>
              <th style="width:313px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in storeList"
                :key="index">
              <td>{{ item.title }}</td>
              <td>
                <span v-show="item.state == 1">未推送，待审核</span>
                <span v-show="item.state == 3">审核通过，已发布</span>
                <span v-show="item.state == 2">审核未通过
                  <span v-show="item.approvRemark">（{{ item.approvRemark }}）</span>
                </span>
              </td>
              <td>
                <div style="background:#C32424"
                     v-show="item.state == 1||item.state == 2"
                     @click="toDeleteResources(item.id)"
                     class="b1btn">删除</div>
                <div style="background:#5590E8"
                     @click="toupdata(item.id)"
                     v-show="item.state == 1||item.state == 2"
                     class="b1btn">修改</div>
                <div style="background:#0B8586"
                     v-show="item.state == 3"
                     @click="toDetail(item.id,item.businesId)"
                     class="b1btn">查看</div>
              </td>
            </tr>
            <tr v-show="storeList.length < 1">
              <td colspan="3">暂无资源信息</td>
            </tr>
          </tbody>
        </table>
        <table v-if="b1Index == 2">
          <thead>
            <tr>
              <th>文章题目</th>
              <th style="width:313px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in storeList"
                :key="index">
              <td>{{ item.title }}</td>
              <td>
                <div style="background:#C32424"
                     @click="toDeleteResources(item.id)"
                     class="b1btn">删除</div>
                <div style="background:#5590E8"
                     @click="toupdata(item.id)"
                     class="b1btn">修改</div>
                <div style="background:#0B8586"
                     @click="toSubmitResources(item)"
                     class="b1btn">提交</div>
              </td>
            </tr>
            <tr v-show="storeList.length < 1">
              <td colspan="2">暂无资源信息</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  @page-change="pageChange"></pagination>
    </div>
    <div class="box2"
         v-show="boxIndex == 2">
      <div class="b2Title">
        <span>文章标题</span>
        <input type="text"
               placeholder="请输入标题"
               v-model="resTitle" />
        <div>
          <span :style="resTitle.length > 30 ? 'color:red' : ''">{{ resTitle.length }}</span>
          <span>/</span>
          <span>30</span>
        </div>
      </div>
      <div class="b2Count">
        <span>文章正文</span>
      </div>
      <div class="b2Eidter">
        <div id="eidter"
             ref="editer"
             style="z-index:0"></div>
      </div>
      <div class="b2Count">
        <div style="display:flex;align-items: center;">
          <span>关键词：</span>
          <img src="../../assets/img/icon/jia2.png"
               style="cursor: pointer;"
               @click="isKeywords = true"
               alt="" />
        </div>
      </div>
      <div class="b2Key">
        <div class="keybox"
             v-for="(item, index) in resKeywords.split(',')"
             :key="index"
             v-show="item">
          <span>{{ item }}</span>
          <img src="../../assets/img/icon/x.png"
               style="margin:-10px -4px 0 4px;cursor: pointer;"
               @click="toDelKey(item)"
               alt="">
        </div>
      </div>
      <div class="b2Tip">
        <span>专栏分类为必选项，请谨慎选择，分类标签将出现在个人首页动态专栏处</span>
      </div>
      <div class="b2Count">
        <span>我的文章预览：</span>
      </div>
      <div class="b2Preview">
        <p class="b2PTitle">{{ resTitle }}</p>
        <div v-html="count"></div>
      </div>
      <!-- <div class="b2Agreement">
        <div v-show="!isAgree"
             @click="isAgree=true"
             style="border:1px solid #666666"></div>
        <div v-show="isAgree"
             style="background: #0B8586;"
             @click="isAgree=false">
          <img src="../../assets/img/icon/duigou.png"
               alt="">
        </div>
        <span>我已阅读并接受</span>
        <span style="color:#0B8586">《全科知家内容上传协议》</span>
      </div> -->
      <div class="b2Btn">
        <div @click="Submit(1)">提交文章</div>
        <div @click="Submit(4)"
             style="background: #9EA2A2;">存草稿</div>
      </div>
      <el-dialog title="关键词"
                 :visible.sync="isKeywords"
                 class="stuLead"
                 width="576px">
        <el-form ref="form"
                 label-width="68px">
          <el-form-item label="关键词：">
            <el-input v-model="keywords"
                      placeholder="例：家医签约,适宜技术"></el-input>
          </el-form-item>
          <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #0B8586;margin:0 0 40px 70px">关键词输入时，用逗号隔开输入</span>
        </el-form>
        <div class="xzbtn"
             @click="addKey">保存</div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import E from 'wangeditor';
export default {
  name: 'usInfor',
  data () {
    return {
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
      b1Index: 1,
      draftNum: 0,
      storeList: [],
      orgid: 0,
      resTitle: '',
      resKeywords: '',
      boxIndex: 1,
      isKeywords: false,
      keywords: '',
      count: '',
      editor: null,
      isAgree: false
    };
  },
  created () {
    this.orgid = Number(localStorage.getItem('storeId'));
    if (this.boxIndex == 1) {
      this.GetMyStoreList();
      this.GetDraftNum();
    }
  },
  watch: {
    boxIndex (e) {
      if (e == 2 && this.editor == null) {
        var that = this;
        that.editor = new E(this.$refs.editer);
        that.editor.config.menus = [
          'head',
          'bold',
          'fontSize',
          'fontName',
          'italic',
          'underline',
          'strikeThrough',
          'indent',
          'lineHeight',
          'foreColor',
          'link',
          'list',
          'justify',
          'image',
          'undo',
          'redo'
        ];
        that.editor.config.onchange = function (newHtml) {
          that.count = newHtml;
        };
        // 配置触发 onchange 的时间频率，默认为 200ms
        that.editor.config.onchangeTimeout = 500; // 修改为 500ms
        // that.editor.config.uploadImgServer = 'https://api.gp519.com/api​/OssFileApi​/ImageUpload'
        that.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
          const formData = new FormData();
          formData.append('file', resultFiles[0]);
          //   formData.append('Authorid', 0);
          formData.append('OfType', 2);
          that.httphelper.post('/api/OssFileApi/ImageUpload', formData).then(res => {
            if (res.data.code) {
              insertImgFn(res.data.data.src)
            } else {
              that.$message('上传失败');
            }
          });
        }
        that.editor.create();
      }
    },
    b1Index () {
      this.GetMyStoreList();
      this.GetDraftNum();
    },
    // isKeywords () {
    //   this.keywords = ''
    // }
  },
  methods: {
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList();
    },
    GetMyStoreList () {
      this.httphelper
        .post('/api/EnterpriseApi/GetSysArticleDynamicList', {
          type: 1,
          busName: '',
          businesId: this.orgid,
          approvalStatus: this.b1Index == 1 ? 0 : 4,
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data;
            this.pageCount = res.data.totalcount;
          }
        });
    },
    GetDraftNum () {
      this.httphelper
        .post('/api/EnterpriseApi/GetSysArticleDynamicList', {
          type: 1,
          busName: '',
          businesId: this.orgid,
          approvalStatus: 4,
          page: this.pageIndex,
          limit: 99
        })
        .then(res => {
          if (res.data.code == 200) {
            this.draftNum = res.data.totalcount;
          }
        });
    },
    addKey () {
      this.keywords = this.keywords.replace(/，/g, ",")
      if (this.resKeywords == '') this.resKeywords = this.keywords;
      else this.resKeywords = this.resKeywords + ',' + this.keywords;
      this.keywords = '';
      this.isKeywords = false;
    },
    Submit (type) {
      //   if (this.isAgree == false) return this.$message.warning('请阅读并勾选协议');
      this.httphelper
        .post('/api/EnterpriseApi/SaveArticleDynamic', {
          id: 0,
          businesId: this.orgid,
          busType: 1,
          title: this.resTitle,
          contentText: this.count,
          labelName: this.resKeywords,
          sort: 0,
          hits: 0,
          releaseTime: '',
          state: type,
          approvRemark: '',
          createUserID: JSON.parse(localStorage.getItem('ResData')).id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList();
            this.GetDraftNum();
            if (type == 1) this.$message.success('提交成功');
            else if (type == 4) this.$message.success('存草稿成功');
            this.boxIndex = 1
          }
        });
    },
    toDeleteResources (id) {
      this.httphelper
        .post('/api/EnterpriseApi/DelArticleDynamic', {
          id: id,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList();
            this.GetDraftNum();
            this.$message.success('删除成功');
          }
        });
    },
    toSubmitResources (item) {
      this.httphelper
        .post('/api/EnterpriseApi/SaveArticleDynamic', {
          id: item.id,
          businesId: item.businesId,
          busType: 1,
          title: item.title,
          contentText: item.contentText,
          labelName: item.labelName,
          sort: 0,
          hits: 0,
          releaseTime: '',
          state: 1,
          approvRemark: '',
          createUserID: JSON.parse(localStorage.getItem('ResData')).id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList();
            this.GetDraftNum();
            this.$message.success('提交成功');
          }
        });
    },
    toupdata (id) {
      this.$router.push({
        name: 'uaUpdateDynamic',
        query: {
          id: id,
        },
      })
    },
    toDetail (id, expertId) {
      window.open('/expertsDetail?id=' + expertId + '&type=' + id, '_blank')
    },
    toDelKey (name) {
      let arr = this.resKeywords.split(',')
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == name) {
          arr.splice(i, 1);
        }
      }
      this.resKeywords = arr.join(',')
    }
  }
};
</script>

<style scoped>
.box1 {
    padding-top: 10px;
}
.b1top {
    margin: 20px 0;
    height: 18px;
    line-height: 18px;
    padding-left: 14px;
    border-left: 2px solid #0b8586;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.b1top span {
    margin-right: 40px;
    cursor: pointer;
}
.b1tr {
    display: flex;
    align-items: center;
}
.b1tr img {
    margin-right: 10px;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.b1btn {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
}
.b1fengmian {
    width: 65px;
    height: 45px;
}
.box2 {
    padding-top: 20px;
}
.b2Title {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.b2Title input {
    flex: 1;
    margin: 0 10px;
    border: none;
    outline: none;
}
.b2Count {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.b2Btn {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
}
.b2Btn div {
    width: 148px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    margin: 0 5px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.b2Key {
    display: flex;
    flex-wrap: wrap;
}
.keybox {
    height: 30px;
    border: 1px solid #0b8586;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    line-height: 30px;
    padding: 0 12px;
    margin-bottom: 10px;
    margin-right: 14px;
    position: relative;
}
.keybox img {
    position: absolute;
    top: 2px;
    right: -4px;
    cursor: pointer;
    background-color: #fff;
    border-radius: 50%;
}
.b2Tip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
}
.b2Preview {
    width: 100%;
    height: 333px;
    border: 1px solid #e2e2e2;
    padding: 30px;
    box-sizing: border-box;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.b2Preview::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.b2Preview::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.b2Preview::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #eee;
    border-radius: 6px;
}
.b2Preview .b2PTitle {
    margin-bottom: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    text-align: center;
}
.b2Agreement {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 56px;
}
.b2Agreement div {
    width: 15px;
    height: 15px;
    box-sizing: border-box;
    margin-right: 10px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.b2Eidter ::v-deep .w-e-toolbar {
    z-index: 201 !important;
}
.b2Eidter ::v-deep .w-e-text-container {
    z-index: 200 !important;
}
.stuLead ::v-deep .el-dialog {
    padding: 50px 52px;
    border-radius: 10px;
}
.stuLead ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.stuLead ::v-deep .el-dialog__header {
    padding: 0;
    margin-bottom: 30px;
}
.stuLead ::v-deep .el-dialog__body {
    padding: 0;
}
.xzbtn {
    margin-top: 35px;
    margin-left: 136px;
    width: 200px;
    height: 40px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
</style>
